import { Theme } from '@mui/material/styles';

// ==============================|| CUSTOM FUNCTION - COLORS ||============================== //

export default function getColors(theme: Theme, color: string) {
  switch (color) {
    case 'secondary':
      return theme.vars?.palette?.secondary || theme.palette.secondary;
    case 'error':
      return theme.vars?.palette?.error || theme.palette.error;
    case 'warning':
      return theme.vars?.palette?.warning || theme.palette.warning;
    case 'info':
      return theme.vars?.palette?.info || theme.palette.info;
    case 'success':
      return theme.vars?.palette?.success || theme.palette.success;
    default:
      return theme.vars?.palette?.primary || theme.palette.primary;
  }
}
